let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8FXkX")).then(() => parcelRequire('6OBnQ'));